import { render, staticRenderFns } from "./addPersonnel.vue?vue&type=template&id=5fd2a404&scoped=true"
import script from "./addPersonnel.vue?vue&type=script&lang=js"
export * from "./addPersonnel.vue?vue&type=script&lang=js"
import style0 from "./addPersonnel.vue?vue&type=style&index=0&id=5fd2a404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd2a404",
  null
  
)

export default component.exports